import type React from 'react'
import { useFocusManager } from '@react-aria/focus'

export function useArrowNavigation(
  onKeyDownFallback?: React.KeyboardEventHandler<HTMLElement>
) {
  const focusManager = useFocusManager()
  return function onKeyDown(event: React.KeyboardEvent<HTMLElement>) {
    if (onKeyDownFallback) {
      onKeyDownFallback(event)
    }

    if (event.defaultPrevented) {
      return
    }

    if (event.key === 'ArrowDown') {
      focusManager?.focusNext({ wrap: true })
      event.stopPropagation()
    }
    if (event.key === 'ArrowUp') {
      focusManager?.focusPrevious({ wrap: true })
      event.stopPropagation()
    }
  }
}
